let debugMode = false;
let verboseMode = false;
const verboseEventsMap = {
    adprogress: true,
    progress: true,
    timeupdate: true,
};
export function setDebugMode(debugLevel) {
    if (typeof debugLevel === 'undefined') {
        return;
    }
    verboseMode = debugLevel === 'verbose';
    debugMode = Boolean(debugLevel);
}
export function debug(message, ...args) {
    if (!debugMode) {
        return;
    }
    if (!verboseMode && verboseEventsMap[message]) {
        return;
    }
    console.log(`[DEBUG][MediaPlayer] ${message}`, ...args);
}
